<div class="btn-group d-block primary-dropdown w-100" dropdown #dropdown="bs-dropdown" [isDisabled]="disabled">
  <button class="h-100 w-100 d-flex primary-dropdown-toggle medium-text" dropdownToggle type="button" aria-controls="dropdown-menu" [ngClass]="{selected : !!selectedItem}" role="button">
    <span class="primary-dropdown-selected-item medium-text d-block mr-xs text-truncate">{{resolveName(selectedItem)}}</span>
    <span class="primary-dropdown-arrow">
      <img src="https://staticcontent.knowledgehook.com/content/icons/directional/friendly/chevron-{{ dropdown.isOpen ? 'up' : 'down' }}.svg">
    </span>
  </button>
  <ul class="dropdown-menu primary-dropdown-list border-radius-sm mt-xs" *dropdownMenu id="dropdown-menu" role="menu" aria-labelledby="button-animated">
    <li *ngFor="let item of items" role="button" class="primary-dropdown-item medium-title-text black p-xxs m-xs border-radius-sm" (click)="onItemClick(item)">
      {{resolveName(item)}}
    </li>
  </ul>
</div>
